<template>
    <ideo-form-group>
        <units :form-errors="form.$errors" v-model="form.units" :label="'[[[Widget dostępny dla wydziałów]]]'" :title="$t('units')" />
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import { FormType } from '@/helpers/Form';
import { ValidatableComponent } from '@/components/cms';
import merge from 'lodash/merge';
import Units from '@/components/common/Units.vue';

interface FormSettings
{
    settings: any;
}

@Options({
    name: 'widget-points-dashboard-settings',
    components: {
        'units': Units,
    }
})
export default class PointsDashboardSettings extends Vue implements ValidatableComponent
{
    @Prop() public modelValue!: any;

    public module: string = 'points-dashboard';
    public defaults: any = {
        page: null,
    };

    public get form(): FormType<FormSettings>
    {
        return this.modelValue;
    }

    public async created(): Promise<void>
    {
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', { deep: true })
    public onSettingsChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        return this.form;
    }

    public async validate(): Promise<void>
    {
        this.form.validate(schema => ({
            settings: schema.object({
            })
        }));
    }
}
</script>
